import { createFileRoute } from "@tanstack/react-router"
import { UserBlockedScreen } from "@/widgets/user-blocked-screen"

export const Route = createFileRoute("/user-blocked")({
	component: UserBlockedPage,
})

function UserBlockedPage() {
	return <UserBlockedScreen open />
}
